import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class TipoIngresoService {

  constructor(private gqlclient: GraphQLClient) { }

  obtenerTodos(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          tipo_ingreso {
            obtenerTodos {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_ingreso.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }
}